import { useAuth } from "@/contexts/AuthContext";

export function MoneyDisplay({ amount, className = "", size = "md" }) {
  const { formatMoney } = useAuth();
  const sizes = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-lg",
    lg: "text-2xl",
    xl: "text-4xl",
  };
  return (
    <span className={`font-mono tabular font-semibold ${sizes[size]} ${className}`}>
      {formatMoney(amount)}
    </span>
  );
}

export function OwnershipBadge({ state }) {
  const colors = {
    OWNED: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    CUSTODY: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    RESTRICTED: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    ASSIGNED: "bg-rose-500/15 text-rose-400 border-rose-500/30",
    ENCUMBERED: "bg-purple-500/15 text-purple-400 border-purple-500/30",
  };
  return (
    <span className={`inline-flex items-center text-[10px] font-mono px-2 py-0.5 rounded-full border ${colors[state] || colors.CUSTODY}`}>
      {state}
    </span>
  );
}

export function PermissionBadge({ permission }) {
  const colors = {
    FREE: "text-emerald-400",
    RESTRICTED: "text-amber-400",
    PROHIBITED: "text-red-400",
  };
  return (
    <span className={`text-[10px] font-mono ${colors[permission] || "text-slate-400"}`}>
      {permission}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const colors = {
    CRITICAL: "bg-red-500/15 text-red-400 border-red-500/30",
    HIGH: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    MEDIUM: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    LOW: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  };
  return (
    <span className={`inline-flex items-center text-[10px] font-mono px-2 py-0.5 rounded border ${colors[priority] || colors.MEDIUM}`}>
      {priority}
    </span>
  );
}
